import { render, staticRenderFns } from "./FUniswapPools.vue?vue&type=template&id=d2fba23e&"
import script from "./FUniswapPools.vue?vue&type=script&lang=js&"
export * from "./FUniswapPools.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports